import axios from 'axios';

const publicClient = axios.create({
	baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
});

export const sendPublicSample = async ({
	email,
	name,
	sampleType,
	website = '',
}) => {
	const response = await publicClient.post('/public/send-sample/', {
		email,
		name: name || '',
		sample_type: sampleType,
		website,
	});
	return response.data;
};

export const requestPasswordReset = async (email) => {
	const response = await publicClient.post('/auth/password-reset/', { email });
	return response.data;
};

export const confirmPasswordReset = async ({ uid, token, new_password }) => {
	const response = await publicClient.post('/auth/password-reset/confirm/', {
		uid,
		token,
		new_password,
	});
	return response.data;
};

export const fetchPaymentConfirmation = async (sessionId) => {
	const response = await publicClient.get('/public/payment-confirmation/', {
		params: { session_id: sessionId },
	});
	return response.data;
};

export const fetchPaymentContext = async (bidId) => {
	const response = await publicClient.get('/public/payment-context/', {
		params: { bid_id: bidId },
	});
	return response.data;
};

export const fetchBidResponseContext = async (bidId, token) => {
	const params = { bid_id: bidId };
	if (token) {
		params.token = token;
	}
	const response = await publicClient.get('/public/bid-response-context/', {
		params,
	});
	return response.data;
};

export const revokeBidAcceptance = async ({ token, bidId }) => {
	try {
		const payload = { token };
		if (bidId) {
			payload.bid_id = bidId;
		}
		const response = await publicClient.post(
			'/public/revoke-acceptance/',
			payload,
		);
		return response.data;
	} catch (error) {
		const detail =
			error.response?.data?.detail ||
			error.message ||
			'Could not cancel acceptance.';
		throw new Error(detail);
	}
};
